import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 17 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.657 3.606h3.241a1.62 1.62 0 1 0-3.24 0Zm-1.215 0a2.836 2.836 0 1 1 5.671 0h4.659a.608.608 0 0 1 0 1.216h-1.07l-.947 9.812a3.038 3.038 0 0 1-3.026 2.745H5.826a3.038 3.038 0 0 1-3.024-2.745l-.949-9.812H.783a.608.608 0 1 1 0-1.216h4.66Zm1.62 3.849a.608.608 0 0 0-1.215 0v6.076a.608.608 0 0 0 1.215 0V7.455Zm3.039-.608a.608.608 0 0 1 .607.608v6.076a.607.607 0 1 1-1.215 0V7.455a.608.608 0 0 1 .608-.608Zm-6.09 7.67a1.823 1.823 0 0 0 1.815 1.647h4.903a1.823 1.823 0 0 0 1.815-1.647l.938-9.695H3.073l.938 9.695Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }